import React, { PropTypes, PureComponent } from 'react';
import cn from 'classnames';

import {
  Card,
  Progressbar,
  Messagebar,
  Dropdown,
  Input,
  Button,
} from '../../shared';
import './styles.scss';
import messages from './i18n';

const FULL_ACCESS = ['organisation_admin', 'payroll_officer'];
const GENERAL_MANAGER = 'roster_manager';
const TEAM_MANAGER = 'manager';

/**
 * This component is the card view for registering a device / location
 */
export class Register extends PureComponent {
  constructor(props) {
    super(props);
    this.renderAccessWarnings = this.renderAccessWarnings.bind(this);
    this.renderLocation = this.renderLocation.bind(this);
    this.submitForm = this.submitForm.bind(this);
    let location;

    if (props.account.locations.length === 1) {
      const { id, name } = props.account.locations[0];
      location = { id, name };
    } else {
      location = {
        id: '',
        name: '',
      };
    }

    this.state = {
      nickname: '',
      location,
      sending: false,
    };
  }

  getButtonClass() {
    return this.state.sending ? 'fa-circle-o-notch fa-spin' : 'fa-arrow-right';
  }

  async submitForm(event) {
    event.preventDefault();
    if (this.state.sending) {
      return;
    }
    // pause the pressing of the button
    this.setState({ sending: true }, () => {
      this.props.registerDevice(this.state.nickname, this.state.location).then((d) => {
        if (d) {
          this.props.next();
        } else {
          this.setState({ sending: false });
        }
      }).catch(() => this.setState({ sending: false }));
    });
  }

  updateLocation(id) {
    const [location] = this.props.account.locations.filter(loc => loc.id.toString() === id);
    if (location) {
      this.setState({
        location: {
          id: location.id,
          name: location.name,
        },
      });
    } else {
      this.setState({
        location: {
          id: '',
          name: '',
        },
      });
    }
  }

  renderAccessWarnings() {
    const me = this.props.account.authUser;
    if (me === undefined) { // legacy setup never stashed me in storage
      return null;
    }

    const { fullAccess, genManager, teamManager } =
      (me.userLevels || []).reduce((acc, level) => ({
        fullAccess: acc.fullAccess || FULL_ACCESS.indexOf(level) !== -1,
        genManager: acc.genManager || level === GENERAL_MANAGER,
        teamManager: acc.teamManager || level === TEAM_MANAGER,
      }), {});

    if (fullAccess || (genManager && !teamManager)) {
      return null;
    }

    return (
      <p className="Register__managerWarning">
        <i className="fa fa-info-circle" aria-hidden="true" />
        { this.props.intl.formatMessage(messages.managerWarning)}
      </p>
    );
  }

  renderNotification() {
    if (this.props.notifications.length > 0) {
      const notification = this.props.notifications[0];
      return (<Messagebar
        index={0} // in the future, this should be the actual message index
        className="Auth__notification"
        remove={this.props.removeNotification}
        {...notification}
      />);
    }

    return null;
  }

  renderLocation() {
    const { locations } = this.props.account;

    if (locations.length === 1) {
      return (
        <div>
          <label className="RegisterForm__label">{this.props.intl.formatMessage(messages.location)}</label>
          <div className="RegisterForm__text">{locations[0].name}</div>
        </div>
      );
    } else if (locations.length > 0) {
      return (<Dropdown
        key={3}
        className='RegisterForm__Drop'
        name='Location'
        value={locations.length === 1 ? locations[0].name : null}
        placeholder={this.props.intl.formatMessage(messages.selectLocation)}
        options={locations.map(location => ({
            name: location.name,
            value: location.id,
          }))}
        onChange={event => this.updateLocation(event.target.value)}
      />);
    }
    return null;
  }

  render() {
    return (
      <div className='Register'>
        <Card>
          <Progressbar>
            <div className='progress' />
          </Progressbar>

          <form className='RegisterForm' onSubmit={event => this.submitForm(event)}>
            {this.renderAccessWarnings()}
            {this.renderLocation()}
            <Input
              className='RegisterForm__input'
              name={this.props.intl.formatMessage(messages.nickname)}
              placeholder={this.props.intl.formatMessage(messages.optional)}
              value={this.state.nickname}
              onChange={event => this.setState({ nickname: event.target.value })}
            />
            <div className="RegisterFormControls">
              <Button
                className='RegisterForm__button green'
                type='submit'
                disabled={this.state.sending}
              >
                <p>
                  {this.props.intl.formatMessage(messages.next)}
                  <i className={cn('fa', this.getButtonClass())} aria-hidden="true" />
                </p>
              </Button>
            </div>
          </form>
        </Card>
      </div>
    );
  }
}

Register.propTypes = {
  account: PropTypes.object,
  removeNotification: PropTypes.func,
  next: PropTypes.func,
  notifications: PropTypes.array,
  registerDevice: PropTypes.func,
};

export default Register;



// WEBPACK FOOTER //
// ./src/components/setup/register/index.jsx